
import { Component, Mixins } from "vue-property-decorator";
import { CommonComponentsContainer } from "../contents";

@Component
export default class CommonComponentsAccessibleMixin extends Mixins() {
  getCommonComponents(): CommonComponentsContainer {
    return this.$findAncestor(s => !!s.$refs.commonComponents).$refs.commonComponents as CommonComponentsContainer;
  }
}
